<app-label *ngFor="let label of labels" [label]="label" [isEditable]="isEditable" (removeFromCollection)="remove($event)"></app-label>
